import { createComponent } from '@carvana/merch-components';

export const TopLabel = createComponent('div', {
  className: 'flex h-80 flex-col items-start gap-xl self-stretch'
});

export const Heading = createComponent('div', {
  className: 'flex min-h-36 items-center justify-between self-stretch'
});

export const Header = createComponent('div', {
  className: 'flex items-center gap-lg'
});

export const Icon = createComponent('span', {
  className: 'flex h-24 w-24 items-center justify-center gap-md rounded-none'
});

export const Typography = createComponent('span', {
  className: 'text-text-strong t-heading-md'
});

export const SwitchContainer = createComponent('div', {
  className: 'flex items-center gap-xl rounded-none'
});

export const Text = createComponent('div', {
  'aria-live': 'polite',
  className: 'self-stretch text-text-default t-body-sm',
  role: 'status'
});

export const Divider = createComponent('div', {
  className:
    'w-full border-b border-l-0 border-r-0 border-t-0 border-solid border-border-subtle'
});

export const Content = createComponent('div', {
  className: 'flex min-h-80 flex-col justify-center'
});
